// This file is used in blockpages.

import jQuery from 'jquery';
import { dust } from '../dust-loader';
import '../vendor/dustjs-helpers/dist/dust-helpers';
import * as API from '../API/API';
import * as Utilities from '../utilities/legacy-utilities';
import audiojs from '../vendor/audiojs/audiojs-loader';

import '../outerHTML/jquery.outerHTML';
import '../vendor/bootstrap2/bootstrap-tooltip';
import '../vendor/bootstrap2/bootstrap-popover';
import '../vendor/bootstrap2/bootstrapx-clickover';
import '../vendor/jquery/plugins/timeago';

import './templates/main.dust';
import './templates/comments.dust';
import './templates/comment.dust';
import './templates/voting.dust';
import './templates/actions.dust';
import './templates/heading.dust';
import { dataMultiLoader } from '../utilities/dataLoader';

import { Store } from '../../ReduxStorage/Store';
import { isCurrentCourseRTLSelector } from '../../ReduxStorage/Courses/selectors';

import './commenting.scss';
import '../containers/Comments/Thread/Thread.scss';
import '../containers/Comments/Header/Header.scss';
import '../containers/Comments/Options/Options.scss';

import {
  mount as mountReplyForm,
  unmount as unmountReplyForm,
} from '../components/Comments/ReplyForm/ReplyForm';
import { mount as mountImageAttachment } from '../components/Comments/Attachments/ImageAttachment';
import {
  mountBasic as mountBasicIFramelyMedia,
  unmount as unmountIFramelyMedia,
} from '../components/IFramelyMedia/IFramelyMedia';
import { OL_ORIGIN } from '../../ReduxStorage/location/constants';
import { makeMetricsLogEvent } from '../../ReduxStorage/Metrics/manualEventDispatchers';

/* global _IMAGES_URL _MEDIA_URL */

export default (function($) {
  var DEFAULT_OPTIONS = {
    MAX_VISIBLE_LIKERS: 2, // not including yourself
    WINDOW_RESIZE_TIMEOUT: 10000, // 10s
    EMPTY_ATTACHMENT_TEXT: 'Attach a file',
    visibleComments: [],
    placeholder: 'Write a comment...',
    cancomment: true,
    resourcename: 'page',
    showSortingOptions: true,
    limit: 30,
    onCommentPosted: () => {
      // console.log('comment-made');
    },
  };

  var SORTING_OPTIONS = {
    time: 'New Threads',
    likes: 'Top Rated',
    bump: 'Recent Replies',
    replies: 'Most Replies',
  };

  var commentHash = /^#comment-([a-f\d]+)$/;

  var hashchange = function() {
    setTimeout(function() {
      $(window).scrollTop($(window).scrollTop() - $(window).height() / 3);
    }, 100);
  };

  function initialise(element, options) {
    // For after you hashchange on a local link, put it 1/3 of the way down the page
    $(window).on('hashchange', hashchange);

    var $element = $(element);
    options.visibleComments = getVisibleComments();
    var settings = $.extend({}, DEFAULT_OPTIONS, $element.data(), options);

    if (settings.placeholder.length === 0) {
      settings.placeholder = DEFAULT_OPTIONS.placeholder;
    }
    if (!settings.resourcename) {
      settings.resourcename = DEFAULT_OPTIONS.resourcename;
    }

    var context = {
      OL_ORIGIN,
      MEDIA_URL: _MEDIA_URL,
      IMAGES_URL: _IMAGES_URL,
      document: settings.document,
      documentUrl: settings.documenturl,
      attachmentText: settings.EMPTY_ATTACHMENT_TEXT,
      placeholder: settings.placeholder,
      user: window.OpenLearningUserData,
      collapsed: settings.collapsed,
      cancomment: settings.cancomment,
      resourceName: settings.resourcename,
      showSortingOptions: settings.showSortingOptions,
      multiEvent: window.location.search.indexOf('multiEvent') !== -1,
      sorts: $.map(SORTING_OPTIONS, function(value, key) {
        return { key: key, text: value };
      }),
      groupId: settings.groupId,
      resourceId: settings.document,
      onCommentPosted: settings.onCommentPosted,
    };
    var comments = {};
    var reactReplyForms = [];

    // helper method to find the right place to insert new comments and reply form
    const findEndOfCommentContext = (targetCommentId) => {
      const targetComment = comments[targetCommentId];
      const allCommentsUnderTarget = {};

      const getChildrenComments = (comment) => {
        const children = comment.children || [];

        children.forEach((child) => {
          allCommentsUnderTarget[child.id] = child;

          getChildrenComments(child);
        });
      };
      getChildrenComments(targetComment);

      // top level comment
      if (!targetCommentId) {
        return null;
      }

      // nested comment
      const $targetContainer = $(`#comment-container-${targetCommentId}`);
      let $lastCommentInContext = $targetContainer;

      $targetContainer.nextAll('.comment-container').each((index, el) => {
        const commentId = $(el)
          .attr('id')
          .split('-')[2];

        if (allCommentsUnderTarget[commentId]) {
          $lastCommentInContext = $(el);
        }
      });

      return $lastCommentInContext;
    };

    // "dispatcher" for react ReplyForm
    const onSubmitComment = (formData) => {
      // must return a promise!
      return new Promise((resolve, reject) => {
        $.ajax({
          url: '/commenting/add/',
          type: 'POST',
          data: formData,
          dataType: 'json',

          // these are required for using FormData()
          processData: false,
          contentType: false,
        })
          .done((response) => {
            resolve(response);
          })
          .fail((...args) => {
            reject(Error('Failed to post comment.'));
          });
      });
    };

    // react ReplyForm callback
    const onCommentPosted = (comment, formContext) => {
      const { indent } = formContext;

      const data = {
        indent,
        parentComment: comment.parentComment,
        comments: [comment],
        collapsed: false,
      };

      // correctly set values of amounts of children comments
      let currParentCommentId = comment.parentComment;
      while (
        currParentCommentId &&
        comments.hasOwnProperty(currParentCommentId)
      ) {
        var currParentComment = comments[currParentCommentId];
        currParentComment.numTreeChildren++;
        if (comment.parentComment === currParentCommentId) {
          currParentComment.numChildren++;
          if (currParentComment.children) {
            currParentComment.children.push(comment);
          } else {
            currParentComment.children = [comment];
          }
        }
        currParentCommentId = currParentComment.parentComment;
      }

      let parentAuthor;
      if (
        comment.parentComment &&
        comments.hasOwnProperty(comment.parentComment)
      ) {
        parentAuthor = comments[comment.parentComment].author;
      }

      if (context.onCommentPosted) {
        context.onCommentPosted();
      }

      dust.render(
        'web/comments/templates/comments.dust',
        preProcess(
          $.extend({ parentAuthor: parentAuthor }, context, data),
          settings,
          comments
        ),
        (err, html) => {
          var $html = postRender(html, settings);

          if (comment.parentComment) {
            const $parentContainer = $(
              `#comment-container-${comment.parentComment}`
            );
            $html.insertAfter($parentContainer);

            // unmount reply form
            const $replyMount = $html.next('.reply');
            reactReplyForms = reactReplyForms.filter(
              (el) => el !== $replyMount[0]
            );
            unmountReplyForm($replyMount[0]);
            $replyMount.remove();
          } else {
            var $comments = $element.find('> .comments');
            // new top level comments are inserted AFTER pinned comments
            var $mostRecentComment = $comments
              .find('.comment-container')
              .not('.pinned-comment')
              .first();
            if ($mostRecentComment.length === 1) {
              $mostRecentComment.before($html);
            } else {
              $comments.append($html);
            }
          }
          audiofy();
        }
      );
    };

    // unmount all the react reply forms
    function destroyAllReplyForms() {
      reactReplyForms.forEach((el) => {
        unmountReplyForm(el);
      });

      // empty the array
      reactReplyForms = [];
    }

    dust.render(
      'web/comments/templates/main.dust',
      $.extend({}, context, { loading: true }),
      function(err, html) {
        if (err) {
          if (typeof console !== 'undefined') {
            console.error(err);
          } else {
            alert(err);
          }
        }
        $element.html(html);

        // top level reply form
        const $replyForm = $element.find('.reply-form-mount');
        const props = {
          onSubmit: onSubmitComment,
          onPost: onCommentPosted,
        };
        Object.assign(props, context, $replyForm.data());
        mountReplyForm($replyForm[0], props);
        reactReplyForms.push($replyForm[0]);

        var match = commentHash.exec(location.hash);
        if (match) {
          settings.visibleComments.splice(0, 0, match[1]);
        }
        // TODO: refactor so it's reusable and doesn't use dust
        getComments(settings).done(function(result) {
          context.isAdmin = result.isAdmin;
          context.sorting = result.sorting;

          $element
            .find('.community-comments-heading')
            .text(result.communityOptions.commentsHeading);
          context.placeholder = result.communityOptions.commentPlaceholder;

          // There's a hard to reproduce bug where sometimes the cancomment is set to false incorrectly.
          // In the getComments we get from the server again whether the user can comment on this page
          if (
            !context.cancomment &&
            result.userCommunityOptions &&
            result.userCommunityOptions.canPostComments
          ) {
            context.cancomment = true;
          }

          dust.render(
            'web/comments/templates/main.dust',
            preProcess($.extend({}, context, result), settings, comments),
            function(err, html) {
              destroyAllReplyForms();

              $element.empty().html(postRender(html, settings));
              //$element.contents().replaceWith(postRender(html, settings));

              const $replyForm = $element.find('.reply-form-mount');
              const props = {
                onSubmit: onSubmitComment,
                onPost: onCommentPosted,
              };
              Object.assign(props, context, $replyForm.data());
              mountReplyForm($replyForm[0], props);
              reactReplyForms.push($replyForm[0]);

              $element
                .find('.sorting-text')
                .text(SORTING_OPTIONS[result.sorting]);

              // subscribe to listen for RTL state changes
              let currentRTL = false;
              const storeHandler = () => {
                const isRightToLeft = isCurrentCourseRTLSelector(
                  Store.getState()
                );

                if (isRightToLeft !== currentRTL) {
                  currentRTL = isRightToLeft;

                  const $elements = $element
                    .find('.comments')
                    .add($element.parent().find('#community-heading-container'))
                    .add($element.find('.comments-listing-options'))
                    .add($element.find('.comment-container-reply'));

                  if (isRightToLeft) {
                    $elements.addClass('dir-right-to-left');
                  } else {
                    $elements.removeClass('dir-right-to-left');
                  }
                }
              };
              const storeUnsubscribe = Store.subscribe(storeHandler);
              $element.data('storeUnsubscribe', storeUnsubscribe);
              storeHandler();

              // Collapse/expand comments
              $element.find('#toggle-comments').click(function(e) {
                e.preventDefault();

                var $comments = $element
                  .find('.comments')
                  .find('.comment-container');

                if (!settings.collapsed) {
                  $(this).text('Expand All');
                  $comments.addClass('collapsed');
                } else {
                  $(this).text('Collapse All');
                  $comments.removeClass('collapsed');
                }

                settings.collapsed = !settings.collapsed;
              });

              settings.visibleComments = $.grep(
                settings.visibleComments,
                function(commentID) {
                  return comments[commentID];
                }
              );

              var $linkedComments = $(
                $.map(settings.visibleComments, function(commentID, i) {
                  return '#comment-container-' + commentID;
                }).join(', ')
              );
              settings.visibleComments = [];

              if ($linkedComments.length) {
                var prevTimeout;

                var jumpToLinkedComment = function(i) {
                  var $window = $(window);
                  var $scrollBody =
                    (settings.scrollBody && $(settings.scrollBody)) ||
                    $('html, body');
                  var $comment = $linkedComments.eq(i);
                  var $commentAnchor = $comment.find('a[id|="comment"]');

                  // remove existing hints
                  $linkedComments.find('.comment-hint').remove();

                  // create a new one
                  var $commentHint = $(
                    $.parseHTML(`
                    <div class="comment-hint">
                        linked here &rarr;
                        <div>
                            <button type="button" title="Previous" class="prev pull-left btn-link"><i class="fa fa-chevron-left"></i> <span class="sr-text">Previous linked comment</span></a>
                            <button type="button" title="Next" class="next pull-right btn-link"><i class="fa fa-chevron-right"></i> <span class="sr-text">Next linked comment</span></a>
                            <span class="clearfix"></span>
                        </div>
                    </div>
                  `)
                  );

                  $('.comment-container.linked').removeClass('linked');
                  $comment.addClass('linked');

                  const hasPrev = i > 0;
                  const hasNext = i < $linkedComments.length - 1;

                  if (hasPrev) {
                    $commentHint.addClass('hasPrev');
                    $commentHint.find('.prev').click((e) => {
                      e.preventDefault();
                      jumpToLinkedComment(i - 1);
                    });
                  } else {
                    $commentHint.find('.prev').remove();
                  }

                  if (hasNext) {
                    $commentHint.push('hasNext');
                    $commentHint.find('.next').click((e) => {
                      e.preventDefault();
                      jumpToLinkedComment(i + 1);
                    });
                  } else {
                    $commentHint.find('.next').remove();
                  }

                  $commentHint.insertAfter($commentAnchor);

                  $scrollBody.scrollTop($commentAnchor.offset().top);
                  $window.on('resize.comment', function() {
                    $scrollBody.scrollTop($commentAnchor.offset().top);
                  });
                  if (prevTimeout) {
                    clearTimeout(prevTimeout);
                  }
                  prevTimeout = setTimeout(function() {
                    $window.off('resize.comment');
                  }, settings.WINDOW_RESIZE_TIMEOUT);
                };

                jumpToLinkedComment(0);
              }
              audiofy();
            }
          );
        });
      }
    );
    $element.on(
      'focus',
      '.comment-container.collapsed textarea.comment-entry',
      expandCommentBox
    );
    $element.on('click', '.comment-reply-link', function(e) {
      // reply to comment
      e.preventDefault();
      var $comment = $(this).closest('.comment-container');
      var $reply = $comment.next('.reply');

      if ($reply.length === 0) {
        var indent = parseInt($comment.attr('data-indent')) || 0;
        var commentID = getCommentID($comment);

        $reply = $('<div></div>').addClass('reply');

        const props = {
          onSubmit: onSubmitComment,
          onPost: onCommentPosted,
        };
        Object.assign(props, context, {
          indent: indent + 1,
          parentComment: commentID,
        });
        mountReplyForm($reply[0], props);

        reactReplyForms.push($reply[0]);

        $reply.insertAfter($comment);
      } else {
        // toggle
        reactReplyForms = reactReplyForms.filter((el) => el !== $reply[0]);
        unmountReplyForm($reply[0]);
        $reply.remove();
      }
    });
    $element.on('click', '.inappropriate-alert, .spoiler-alert', function(e) {
      // toggle comment content
      // we do this via toggleClass instead of a simple toggle
      // as the latter injects inline CSS which breaks
      // collapsing comments (as it always has the highest priority)
      $(this)
        .prev('.comment-content')
        .toggleClass('hide');
    });
    $element.on('click', 'a.load-more-comments', function(e) {
      e.preventDefault();
      var $this = $(this).hide();
      $element.find('.loading').show();
      getComments(settings).done(function(result) {
        dust.render(
          'web/comments/templates/comments.dust',
          preProcess($.extend({}, context, result), settings, comments),
          function(err, html) {
            $element.find('.loading').hide();
            $element.find('.comments').append(postRender(html, settings));
            if (result.hasMoreResults) {
              $this.show();
            }
            audiofy();

            // focus on the first of the comments that are just loaded
            if ('comments' in result && result.comments.length) {
              var firstComment = result.comments[0];
              $('#comment-container-' + firstComment.id).focus();
            }
          }
        );
      });
    });
    $element.on('click', '[data-action="clickover"]', function(e) {
      // If we're getting called it means this link hasn't had clickover run on it yet;
      // run clickover on it & pass through the click event.
      // Note: we can't use the selector option of clickover because our content
      // is on the element which triggered the event, not the one listening for it.
      $(this)
        .clickover({
          html: true,
          onShown: function() {
            var shareInput = this.$tip.find('.share-link-container')[0];

            if (navigator.userAgent.indexOf('Mac OS X') != -1) {
              this.$tip
                .find('.copy-shortcut-text')
                .html('&#x2318; + C to Copy');
            }

            $(shareInput)
              .focus()
              .select();
          },
        })
        .trigger(e);
    });
    $element.on('click', '.comment-actions [data-action="vote"]', function(e) {
      e.preventDefault();
      var $this = $(this);
      var $commentContainer = $this.closest('.comment-container');
      var voteValue = parseInt($this.attr('data-value')) || 0;
      var comment = getCommentData($commentContainer, comments);

      var appWidget = null;
      if (
        $this.closest('.comments-container-main').attr('data-resourcename') ===
        'collection'
      ) {
        appWidget = 'galleryWidget';
      }

      if (comment) {
        var user = context.user;
        var votingData = $.extend(true, { preemptive: true }, comment.voting);
        if (voteValue === 1) {
          votingData.votesUp.push({
            profileName: user.profileName,
            fullName: user.fullName,
            smallAvatar: user.avatar24,
          });
          Store.dispatch(
            makeMetricsLogEvent('UpVote-Made', {
              onObject: 'Comment',
              comment: comment.id,
              appWidget: appWidget,
            })
          );
          votingData.iLike = true;
        } else if (voteValue === -1) {
          Store.dispatch(
            makeMetricsLogEvent('DownVote-Made', {
              comment: comment.id,
              onObject: 'Comment',
              appWidget: appWidget,
            })
          );
          votingData.iDislike = true;
        } else if (votingData.iLike) {
          votingData.iLike = false;
          votingData.votesUp = $.grep(votingData.votesUp, function(voter) {
            return voter.profileName !== user.profileName;
          });
          Store.dispatch(
            makeMetricsLogEvent('DownVote-Made', {
              comment: comment.id,
              onObject: 'Comment',
              appWidget: appWidget,
            })
          );
        } else {
          Store.dispatch(
            makeMetricsLogEvent('UpVote-Made', {
              comment: comment.id,
              onObject: 'Comment',
              appWidget: appWidget,
            })
          );
          votingData.iDislike = false;
        }
        votingData.votesUpCount = votingData.votesUp.length;
        var $voting = $commentContainer.find('.comment-voting');
        var $extraActions = $commentContainer.find('.comment-extra-actions');
        updateWhoLikes(votingData, user, settings);
        dust.render(
          'web/comments/templates/voting.dust',
          $.extend({}, context, votingData),
          function(err, html) {
            var $html = $(html);
            $voting.replaceWith($html);
            $voting = $html;
          }
        );
        dust.render(
          'web/comments/templates/actions.dust',
          $.extend({}, comment, { voting: votingData }, context),
          function(err, html) {
            var $html = $($.parseHTML(html));
            updateActions($extraActions, $html);
            $extraActions = $html;
          }
        );
        $.ajax({
          url: '/voting/vote/',
          dataType: 'json',
          type: 'post',
          data: {
            documentType: 'comment',
            documentId: comment.id,
            voteValue: voteValue,
          },
        })
          .done(function(result) {
            if (result && result.success) {
              delete result.success;
              comment.voting = result;
            }
          })
          .always(function() {
            updateWhoLikes(comment.voting, user, settings);
            dust.render(
              'web/comments/templates/voting.dust',
              $.extend({}, context, comment.voting),
              function(err, html) {
                $voting.replaceWith(html);
              }
            );
            dust.render(
              'web/comments/templates/actions.dust',
              $.extend({}, comment, context),
              function(err, html) {
                updateActions($extraActions, html);
              }
            );
          });
      }
    });
    $element.on(
      'click',
      '.comment-actions a[data-action="report"], .comment-actions a[data-action="delete"]',
      function(e) {
        e.preventDefault();
        var $this = $(this);
        var $comment = $this.closest('.comment-container');
        var action = $this.attr('data-action');
        var comment = getCommentData($comment, comments);
        var data = {
          commentId: comment.id,
          resourceName: settings.resourcename,
        };
        if (action === 'report') {
          data.reason = $this.attr('data-reason');
        }
        $.ajax({
          url: '/commenting/' + action + '/',
          dataType: 'json',
          type: 'post',
          data: data,
        }).done(function(result) {
          if (result && result.success) {
            Store.dispatch(
              makeMetricsLogEvent('comment-delete', { comment: comment.id })
            );
            delete result.success;
            $.extend(comment, result);
            if (
              action !== 'delete' ||
              comment.numTreeChildren > 0 ||
              comment.voting.votesUpCount > 0
            ) {
              dust.render(
                'web/comments/templates/comment.dust',
                $.extend({}, context, comment),
                function(err, html) {
                  // fix for duplicating all the comments as all children comments are returned
                  // in the dust template
                  var level = $comment.attr('data-indent') || 0;
                  $comment
                    .nextUntil(function() {
                      return ($(this).attr('data-indent') || 0) <= level;
                    }, '.comment-container')
                    .remove();
                  $comment.replaceWith(postRender(html, settings));
                  audiofy();
                }
              );
            } else {
              $comment.remove();
            }
            if (action === 'delete') {
              var parentCommentID = comment.parentComment;
              while (
                parentCommentID &&
                comments.hasOwnProperty(parentCommentID)
              ) {
                var parentComment = comments[parentCommentID];
                parentComment.numTreeChildren--;
                if (comment.parentComment === parentCommentID) {
                  parentComment.numChildren--;
                }
                if (
                  parentComment.deleted &&
                  parentComment.numChildren <= 0 &&
                  parentComment.numTreeChildren <= 0
                ) {
                  $('#comment-container-' + parentCommentID).remove();
                }
                parentCommentID = parentComment.parentComment;
              }
            }
          }
        });
      }
    );
    $element.on('click', '.comment-actions a[data-action="feature"]', function(
      e
    ) {
      e.preventDefault();
      var $comment = $(this).closest('.comment-container');
      var comment = getCommentData($comment, comments);
      API.post('commenting/pin', { comment: comment.id }).done(function(
        result
      ) {
        comment.priority = result.commentStatus === 'pinned' ? 1 : 0;
        if (comment.priority > 0) {
          // render the featured comment at the top
          dust.render(
            'web/comments/templates/comment.dust',
            $.extend({ featured: true }, context, comment),
            function(err, html) {
              $element.find('.comments').prepend(postRender(html, settings));
              audiofy();
            }
          );

          Store.dispatch(
            makeMetricsLogEvent('comment-feature', { comment: comment.id })
          );
        } else {
          // remove the featured comment
          $element
            .find('#comment-container-' + comment.id + '-pinned')
            .remove();

          Store.dispatch(
            makeMetricsLogEvent('comment-unfeature', { comment: comment.id })
          );
        }
        dust.render(
          'web/comments/templates/actions.dust',
          $.extend({}, context, comment),
          function(err, html) {
            updateActions($comment.find('.comment-extra-actions'), html);
          }
        );
      });
    });

    var linkify = function(inputText) {
      //URLs starting with http://, https://, or ftp://
      var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      var replacedText = inputText.replace(
        replacePattern1,
        '<a href="$1" target="_blank">$1</a>'
      );

      //URLs starting with www. (without // before it, or it'd re-link the ones done above)
      var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(
        replacePattern2,
        '$1<a href="http://$2" target="_blank">$2</a>'
      );

      //Change email addresses to mailto:: links
      var replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
      replacedText = replacedText.replace(
        replacePattern3,
        '<a href="mailto:$1">$1</a>'
      );

      return replacedText;
    };

    var revokeObjectURL = function(objectURL) {
      // clean up must be done after calling URL.createObjectURL
      if (objectURL && typeof URL !== 'undefined') {
        try {
          URL.revokeObjectURL(objectURL);
        } catch (err) {
          if (typeof console !== 'undefined') {
            console.error(err);
          }
        }
      }
    };

    /* TODO: Added so that OLCommenting can be added to the gallery widget */
    $element.on('click', 'input[type="submit"]', function(e) {
      e.preventDefault();
      $(this)
        .closest('form')
        .submit();
    });

    $element.on('hover', '.comment-in-response-to', function(e) {
      getCommentFromLocation(this).toggleClass('highlighted');
    });
    $element.on(
      'click',
      '.comment-container.collapsed:not(.pinned-comment)',
      function(e) {
        $(this)
          .nextUntil('.comment-container.collapsed:not(.indented)')
          .andSelf()
          .removeClass('collapsed');
      }
    );
    $element.find('a[href|="#comment"]').on('click', function(e) {
      $('.comment-container.linked').removeClass('linked');
      getCommentFromLocation(this).addClass('linked');
    });

    $element.data('OLCommenting.initialised', true);

    $element.on('olcommenting.destroy-all-reply-forms', () => {
      destroyAllReplyForms();
    });
  }

  function destroy(element) {
    var $element = $(element);

    // unsubscribe from Redux store
    const storeUnsubscribe = $element.data('storeUnsubscribe');
    if (storeUnsubscribe) {
      storeUnsubscribe();
    }
    $element.data('storeUnsubscribe', null);

    $element.trigger('olcommenting.destroy-all-reply-forms');

    $element.find('.embed-mount').each((index, el) => {
      unmountIFramelyMedia(el);
    });

    var $clone = $(element).clone(); // Without handlers and data
    $element.replaceWith($clone);
    $element.remove();
    return $clone[0];
  }

  function expandCommentBox(e) {
    var $this = $(this);
    $this.closest('.comment-container').removeClass('collapsed');
    setTimeout(function() {
      $this.next('.comment-entry').focus();
      $this.off('focus', expandCommentBox);
    }, 50);
  }

  function updateWhoLikes(votingData, user, options) {
    if (votingData.votesUpCount > 0) {
      var MAX_VISIBLE_LIKERS = options.MAX_VISIBLE_LIKERS;
      var likers = [];
      if (votingData.iLike) {
        MAX_VISIBLE_LIKERS++;
        likers.push('You');
      }
      $.each(votingData.votesUp, function(j, voter) {
        if (voter.profileName !== user.profileName) {
          likers.push(voter.fullName);
        }
        return likers.length < MAX_VISIBLE_LIKERS;
      });
      var remainingLikers = votingData.votesUp.length - likers.length;
      if (remainingLikers > 0) {
        likers.push(
          remainingLikers + ' other' + (remainingLikers === 1 ? '' : 's')
        );
      }
      var likersText = likers
        .slice(0, -2)
        .concat([likers.slice(-2).join(' and ')])
        .join(', ');
      votingData.whoLikes =
        likersText +
        ' like' +
        (votingData.iLike || likers.length > 1 ? '' : 's') +
        ' this';
    } else if (votingData.whoLikes) {
      votingData.whoLikes = '';
    }
  }

  function updateActions($actions, html) {
    if ($actions.next('.popover').hasClass('in')) {
      $actions.clickover('hide');
    }
    $actions.replaceWith(html);
  }

  function preProcess(data, options, comments) {
    if (options.offset === null || typeof options.offset === 'undefined') {
      options.offset = 0;
    }
    var $existing = $();
    var linkedCommentsStart;
    var preProcessor = function(i, comment) {
      var numWords = $.trim(comment.content).split(/\s+/).length;
      var numNewLines = $.trim(comment.content).split(/\r\n|\r|\n|<br>/).length;
      var wordsPerLine = 15.0;
      var linesInLongComment = 15.0;

      comment.isLongComment =
        Math.max(numWords / wordsPerLine, numNewLines) > linesInLongComment;

      if (comments.hasOwnProperty(comment.id) && comments[comment.id].forced) {
        $existing = $existing.add('#comment-container-' + comment.id);
      }
      if (!comment.featured && comment.depth === 0) {
        if (!comment.forced) {
          options.offset++;
        } else if (
          linkedCommentsStart === null ||
          typeof linkedCommentsStart === 'undefined'
        ) {
          linkedCommentsStart = i;
        }
      }
      if (data.isAdmin || comment.isAuthor) {
        comment.canDelete = true;
      }
      comments[comment.id] = comment;
      updateWhoLikes(comment.voting, data.user, options);

      if (comment.children) {
        $.each(comment.children, preProcessor);
      }
    };
    $.each(data.comments, preProcessor);
    if (
      linkedCommentsStart !== null &&
      typeof linkedCommentsStart !== 'undefined'
    ) {
      data.linkedComments = data.comments.splice(linkedCommentsStart);
    }
    if (
      options.documenturl !== null &&
      typeof options.documenturl !== 'undefined'
    ) {
      data.linkToPost = options.documenturl;
    }
    data.currentUrl = window.url;

    $existing.remove();
    return data;
  }

  function postRender(html, options) {
    var $html = $($.parseHTML(html));
    $html.find('span.comment-timestamp').each(function() {
      var $this = $(this);
      var timestamp = $this.text();
      $this.text(Utilities.parseISODate(timestamp).toLocaleString());
      $this.attr('title', timestamp);
      $this.timeago().tooltip();
    });
    $html.find('span.size').each(function() {
      var $this = $(this);
      $this.text(Utilities.size_format($this.text()));
    });

    // after $html has been added to the dom, mount react
    setTimeout(() => {
      addEmbed($html);

      $html.find('.mount-attached-image').each((index, mount) => {
        const $mount = $(mount);

        $mount.removeClass('mount-attached-image');

        const props = {
          className: 'mobile-expandable',
          src: $mount.data('src'),
          altText: $mount.data('alt'),
          description: $mount.data('description'),
          citationText: $mount.data('cite-text'),
          citationLink: $mount.data('cite-link'),
        };
        mountImageAttachment(mount, props);
      });
    }, 100);

    return $html;
  }

  function addEmbed($html) {
    $html.find('.comment-content').each(function() {
      var commentContent = $(this);
      $(this)
        .find('a')
        .each(function() {
          if (!$(this).hasClass('download-link')) {
            var link = $(this).attr('href');
            if (!/^https?:\/\/www\.openlearning\.com/.test(link)) {
              var mountElement = $('<div>')
                .addClass('embed-mount')
                .attr('data-url', link);
              commentContent.find('.comment-media').append(mountElement);
            }
          }
        });
    });

    $html.find('.embed-mount').each(function(index, el) {
      const props = {
        url: $(el).attr('data-url'),
        maxWidth: 700,
      };

      mountBasicIFramelyMedia(this, props);
    });
  }

  function audiofy() {
    // this has to be done after the html has been added to the DOM
    // because audiojs injects flash and checks for it under document/window
    var $audioElements = $('audio.comment-audiojs').removeClass(
      'comment-audiojs'
    );
    if ($audioElements.length) {
      audiojs.create($audioElements); // create can handle array-like elements
    }
  }

  function getComments(options) {
    var data = {
      document: options.document,
      resourceName: options.resourcename,
      initArg: options.initArg,
      offset: options.offset,
      limit: options.limit,
      cohort: options.cohort,
      groupId: options.groupId,
    };
    if (options.visibleComments.length) {
      data.visibleComments = options.visibleComments.slice(0, 20).join(',');
    }
    return $.ajax({
      url: '/commenting/get/',
      data: data,
      dataType: 'json',
    });
  }

  function getCommentID($comment) {
    return $comment.attr('id').slice('comment-container-'.length);
  }

  function getCommentData($comment, comments) {
    var commentData = null;
    var commentID = getCommentID($comment);
    if (commentID && comments.hasOwnProperty(commentID)) {
      commentData = comments[commentID];
    }
    return commentData;
  }

  function getCommentFromLocation(loc) {
    if (!loc) {
      loc = location;
    }
    return $('#comment-container-' + loc.hash.slice('#comment-'.length));
  }

  function getVisibleComments() {
    var linkedNotificationDataNodes = dataMultiLoader(
      'linked-notification-data'
    );
    if (linkedNotificationDataNodes.length) {
      return linkedNotificationDataNodes[0].relevantCommentIds;
    } else {
      return [];
    }
  }

  $.fn.OLCommenting = function(options) {
    if (options == 'reload') {
      this.each(function(i, element) {});
    } else if (options === 'destroy') {
      this.each((i, element) => {
        if ($(element).data('OLCommenting.initialised')) {
          destroy(element);
        }
      });
    } else {
      this.each(function(i, element) {
        // Destroy the old wrapper and replace in-place to remove handlers
        if ($(element).data('OLCommenting.initialised')) {
          var clone = destroy(element);
          element = clone;
        }

        initialise(element, options);
      });
    }
  };
})(jQuery);
